import React, { useState, useEffect } from 'react';
import StepContainer from './components/StepContainer';
import PrerequisitesCard from './components/PrerequisitesCard';
import ClientConfiguration from './components/ClientConfiguration';
import StatusPill from './components/StatusPill';
import VerifyConnectionSection from './components/VerifyConnectionSection';
import {
  Wrapper,
  StepContentGrid
} from './styled';

const MCP_SERVER_URL = 'https://mcp.apps.faradaysec.com/mcp';

const MCP = () => {
  const [isMcpServerOnline, setIsMcpServerOnline] = useState(false);

  useEffect(() => {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 5000);

    fetch(MCP_SERVER_URL, { method: 'GET', mode: 'no-cors', signal: controller.signal })
      .then(() => setIsMcpServerOnline(true))
      .catch(() => setIsMcpServerOnline(false))
      .finally(() => clearTimeout(timeoutId));

    return () => {
      controller.abort();
      clearTimeout(timeoutId);
    };
  }, []);

  return (
    <Wrapper>
      <StepContainer title="Prerequisites" stepNumber={ 1 }>
        <StepContentGrid>
          <PrerequisitesCard
            headerExtra={ <StatusPill isOnline={ isMcpServerOnline } /> }
            title="MCP Server URL"
            description="https://mcp.apps.faradaysec.com/mcp"
          />
          <PrerequisitesCard
            title="Faraday Instance URL"
            description="Your Faraday server address (e.g. https://your-faraday-instance.com )."
          />
          <PrerequisitesCard
            title="Credentials"
            description="API token, or username + password."
          />
        </StepContentGrid>
      </StepContainer>
      <StepContainer title="Configure your AI Client" stepNumber={ 2 }>
        <ClientConfiguration />
      </StepContainer>
      <StepContainer title="Verify Connection" stepNumber={ 3 }>
        <VerifyConnectionSection />
      </StepContainer>
    </Wrapper>
  );
};

export default MCP;
